import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { Carta, CartaResponse } from 'src/app/modelos/carta';
import { CartaService } from 'src/app/services/carta.service';

@Component({
  selector: 'app-carta-qr',
  templateUrl: './carta-qr.component.html',
  styleUrls: ['./carta-qr.component.css']
})
export class CartaQrComponent implements OnInit {

  destinatarios:any;
  remitentes:any;
  carta:Carta = new Carta();
 
  show:boolean = false;
  constructor(private rutaActiva: ActivatedRoute,private cartaService:CartaService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    /*if(this.rutaActiva.snapshot.params.id ==  this.id){
      this.show = true;
    }*/
    this.spinner.show();  
    this.cartaService.GetById(this.rutaActiva.snapshot.params.id).subscribe(response => {
      this.spinner.hide();
      this.carta = response.cartas[0];
      this.remitentes = response.remitentes;
      this.destinatarios = response.destinatarios;
    });
  
  }

}
